import {
  ShareMyWishOrderWebService,
  RestfulShareMyWishOrderWebService
} from 'ws/ShareMyWishOrderWebService';
import { ShareMyWishOrderSpaces } from './ShareMyWishOrder';

export interface ShareMyWishOrderManager {
  getCampaignSpacesWithin(
    startDate?: string,
    endDate?: string
  ): Promise<ShareMyWishOrderSpaces[]>;
}

export class DefaultShareMyWishOrderManager implements ShareMyWishOrderManager {
  webService: ShareMyWishOrderWebService;

  constructor(
    webService: ShareMyWishOrderWebService = new RestfulShareMyWishOrderWebService()
  ) {
    this.webService = webService;
  }

  getCampaignSpacesWithin(startDate?: string, endDate?: string) {
    return this.webService.getCampaignSpacesWithin(startDate, endDate);
  }
}
